"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Markets = void 0;
const bn_js_1 = __importDefault(require("bn.js"));
exports.Markets = [
    {
        symbol: 'SOL-PERP',
        baseAssetSymbol: 'SOL',
        marketIndex: new bn_js_1.default(0),
        devnetPythOracle: 'J83w4HKfqxwcq3BEMMkPFSppX3gqekLyLJBexebFVkix',
        mainnetPythOracle: 'H6ARHf6YXhGYeQfUzQNGk6rDNnLBQKrenN712K4AQJEG',
    },
    {
        symbol: 'BTC-PERP',
        baseAssetSymbol: 'BTC',
        marketIndex: new bn_js_1.default(1),
        devnetPythOracle: 'HovQMDrbAgAYPCmHVSrezcSmkMtXSSUsLDFANExrZh2J',
        mainnetPythOracle: 'GVXRSBjFk6e6J3NbVPXohDJetcTjaeeuykUpbQF8UoMU',
    },
    {
        symbol: 'ETH-PERP',
        baseAssetSymbol: 'ETH',
        marketIndex: new bn_js_1.default(2),
        devnetPythOracle: 'EdVCmQ9FSPcVe5YySXDPCRmc8aDQLKJ9xvYBMZPie1Vw',
        mainnetPythOracle: 'JBu1AL4obBcCMqKBBxhpWCNUt136ijcuMZLFvTP7iWdB',
    },
    // {
    // 	symbol: 'COPE-PERP',
    // 	baseAssetSymbol: 'COPE',
    // 	marketIndex: new BN(3),
    // 	devnetPythOracle: 'BAXDJUXtz6P5ARhHH1aPwgv4WENzHwzyhmLYK4daFwiM',
    // 	mainnetPythOracle: '9xYBiDWYsh2fHzpsz3aaCnNHCKWBNtfEDLtU6kS4aFD9',
    // },
];
